export default __webpack_public_path__ + "static/hw_ff_servo_schem-2c7a00a35199d0aeff4827f2317f150e.png";